import { PropsWithChildren } from 'react'

import { cn } from '@/shared/lib'
import { Icon } from '@/shared/ui'

import { useToggleRoomList } from '../lib/sidebar'

const Sidebar = ({ children }: PropsWithChildren) => {
  const { isOpen, toggle } = useToggleRoomList()

  const handleRoomListOpenButtonClick = () => {
    toggle()
  }

  return (
    <div
      className={cn(
        'z-sidebar relative bg-white drop-shadow-[0px_0px_4px_rgba(0,0,0,0.45)]',
        !isOpen && '-translate-x-full',
      )}
    >
      {isOpen && children}
      <button
        className={cn(
          'absolute top-10 left-full flex h-[50px] w-8 cursor-pointer items-center justify-end gap-1 rounded-r-lg bg-white px-1',
          !isOpen && 'w-[106px]',
        )}
        onClick={handleRoomListOpenButtonClick}
        aria-label={isOpen ? '방 목록 닫기' : '방 목록 열기'}
      >
        {(() => {
          if (isOpen) {
            return (
              <Icon
                name="arrow-left"
                size={24}
                strokeWidth={1.5}
                className="text-black"
              />
            )
          }

          return (
            <>
              <span className="typo-label2 font-medium text-black">
                방 목록 보기
              </span>
              <Icon
                name="arrow-right"
                size={24}
                strokeWidth={1.5}
                className="text-black"
              />
            </>
          )
        })()}
      </button>
    </div>
  )
}

export default Sidebar
